class TokenService {
    getLocalRefreshToken() {
      const user = JSON.parse(localStorage.getItem("reg_token"));
      return user;
    }
  
    getLocalAccessToken() {
      const user = JSON.parse(localStorage.getItem("reg_token"));
      return user;
    }
  
    updateLocalAccessToken(token) {
      localStorage.setItem("reg_token", token);
    }
  
    getUser() {
      return JSON.parse(localStorage.getItem("reg_token"));
    }
  
    setUser(user) {
      localStorage.setItem("reg_token", JSON.stringify(user));
    }
  
    removeUser() {
      localStorage.removeItem("reg_token");
    }
  }
  
  const service = new TokenService();
  export default service;
  